export default __webpack_public_path__ + "static/media/PoojaV.e30bdfe0.jpg";